import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import user from './user';
import modal from './modal';
import profile from './profile';
import project from './project';

export default (history) => combineReducers({
  firebase: firebaseReducer,
  user,
  modal,
  profile,
  project,
})
